const Support = () => {
  return <p>Support details here</p>
}

export default Support
